import React from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";
import PropTypes from "prop-types";
import { themeSelector } from "../ducks/shopping/selectors";
import { primaryColor, secondaryColor } from "../constants"; // , buttonPrimaryBackgound, buttonPrimaryText

const StyledButton = styled.button`
right: ${(props) => props.right || "auto"};
bottom: ${(props) => props.bottom || "auto"};
position: ${(props) => props.position || "static"};
  background-color: ${(props) =>
    props.outline || props.backgroundColor
      ? props.backgroundColor || "transparent"
      : primaryColor};
  background-image: ${(props) =>
    props.outline || props.backgroundColor
      ? "none"
      : `linear-gradient(91deg, ${primaryColor} 23%, #00929b 82%)`};

  height: ${(props) => props.height || "35px"};
  width: ${(props) => props.width};
  max-width: ${(props) => props.maxWidth};
  border-radius: 20px;
  user-select: none;
  text-align: center;
  color: ${(props) =>
    props.outline || props.color ? props.color || primaryColor : "#fff"};
  outline: none;
  padding: ${(props) => props.padding  || "0px 20px"};
  font-family: "Poppins";
  border: ${(props) =>
    props.outline || props.border
      ? `1px solid ${props.border || primaryColor}`
      : "none"};
  // font-size: 14px;
  font-size: ${(props) => props.fontSize || "14px"};
  margin: ${(props) => props.margin};
  transition-duration: 0.3s;
  cursor: pointer;
  // font-weight: 300;
  font-weight: ${(props) => props.fontWeight || "300"};
  &:hover {
    background-color: ${(props) =>
      props.outline ? props.bgColorHover : secondaryColor}; // express //
    background-image: none;
    opacity: ${(props) => (props.outline || props.opacityHover ? props.opacityHover || 1.0 : 0.5)};
    color: ${(props) => props.colorHover || "#fff"}; // express //
  }
  @media (max-width: 998px) {
    font-size: 12px;
  }
  @media (max-width: 768px) {
    width: ${(props) => props.widthSm};
    padding: ${(props) => props.paddingSm};
    margin: ${(props) => props.marginSm};
  }
`;

function Button({
  onClick,
  children,
  outline,
  backgroundColor,
  height,
  width,
  maxWidth,
  color,
  padding,
  border,
  fontSize,
  margin,
  fontWeight,
  widthSm,
  paddingSm,
  marginSm,
  bgColorHover,
  colorHover,
  position,
  bottom,
  right,
  opacityHover,
}) {

  const theme = useSelector(themeSelector);

  return (
    <StyledButton
      onClick={onClick}
      outline={outline}
      backgroundColor={backgroundColor}
      height={height}
      width={width}
      maxWidth={maxWidth}
      color={color}
      padding={padding}
      border={border}
      fontSize={fontSize}
      margin={margin}
      fontWeight={fontWeight}
      widthSm={widthSm}
      paddingSm={paddingSm}
      marginSm={marginSm}
      bgColorHover={bgColorHover || theme && theme.buttonPrimaryText}
      colorHover={colorHover || theme && theme.buttonPrimaryBackgound}
      position={position}
      bottom={bottom}
      right={right}
      opacityHover={opacityHover}
    >
      {children}
    </StyledButton>
  );
}

Button.propTypes = {
  onClick: PropTypes.func,
  children: PropTypes.string,
  outline: PropTypes.bool,
  backgroundColor: PropTypes.string,
  height: PropTypes.string,
  width: PropTypes.string,
  maxWidth: PropTypes.string,
  color: PropTypes.string,
  padding: PropTypes.string,
  border: PropTypes.string,
  fontSize: PropTypes.string,
  margin: PropTypes.string,
  fontWeight: PropTypes.string,
  widthSm: PropTypes.string,
  paddingSm: PropTypes.string,
  marginSm: PropTypes.string,
  bgColorHover: PropTypes.string,
  colorHover: PropTypes.string,
  position: PropTypes.string,
  bottom: PropTypes.string,
  right: PropTypes.string,
  opacityHover: PropTypes.string,
};

Button.defaultProps = {
  onClick: null,
  children: "",
  outline: false,
  backgroundColor: undefined,
  height: undefined,
  width: undefined,
  maxWidth: "100%",
  color: undefined,
  padding: undefined,
  border: undefined,
  fontSize: undefined,
  margin: undefined,
  fontWeight: undefined,
  widthSm: undefined,
  paddingSm: undefined,
  marginSm: undefined,
  bgColorHover: undefined,
  colorHover: undefined,
  position: undefined,
  bottom: undefined,
  right: undefined,
  opacityHover: undefined,
};

export default Button;
